import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'cygov-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
})
export class CheckboxComponent implements OnInit {
  @Output() changed = new EventEmitter<boolean>();
  @Output() clicked = new EventEmitter<any>();
  @Input() isChecked: boolean;
  @Input() width = 16;
  @Input() height = 16;
  @Input() useViewPortDimensions = false;
  @Input() id = '';
  @Input() disable: boolean = false; // to disable checkbox click
  constructor() {}

  ngOnInit(): void {}
}
